var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'with-menubar':_vm.menubar, 'no-menubar':!_vm.menubar}},[_c('TitleArea',{attrs:{"is-modal":_vm.isModal,"text":_vm.text}}),_vm._v(" "),_c('div',{staticClass:"content-area",class:{'content-with-menubar':_vm.menubar, 'content-no-menubar':!_vm.menubar},attrs:{"id":"content-area"}},[_vm._t("contents")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c47a59","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Templates/TitleFrame.vue
// module id = null
// module chunks = 